import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brand-unsplash', 'BrandUnsplash', [["path",{"d":"M4 11h5v4h6v-4h5v9h-16v-9"}],["path",{"d":"M9 4h6v4h-6l0 -4"}]]);